module.exports = __webpack_public_path__ + "img/177.e5dd98c5.jpg";